export default [
  {
    path: '/app/care-visit',
    redirect: '/app/care-visit/dashboard',
  },
]
